interface Props {
  title: string;
  message: string;
  onClose: () => void;
  variant?: 'error' | 'warning' | 'info';
}

export default function ErrorModal({ title, message, onClose, variant = 'error' }: Props) {
  const iconClass = variant === 'warning' 
    ? 'bi bi-exclamation-circle-fill text-warning'
    : variant === 'info'
    ? 'bi bi-info-circle-fill text-info'
    : 'bi bi-exclamation-triangle-fill text-danger';

  return (
    <div 
      className="modal show d-block feebbo-modal" 
      tabIndex={-1} 
      style={{ backgroundColor: 'rgba(0,0,20,0.7)', backdropFilter: 'blur(4px)' }} 
      onClick={onClose}
    >
      <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className="modal-title d-flex align-items-center gap-2">
              <i className={iconClass} />
              {title}
            </h5>
            <button className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body">
            <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>{message}</p>
          </div>
          <div className="modal-footer border-0">
            <button className="btn btn-feebbo" onClick={onClose}>
              Entendido
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
